// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"811c6a01","453":"d4eb9557","455":"525f1a74","977":"06d469a3"}[chunkId] + ".chunk.js";
};